<template>
  <div style="height:100%">
    <TableMain ref="OrderForecastTable1" name="myName" :fields="fields" :title="table_title.title1"
      :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_date_picker="false"
      :show_toolbar="false" :show_filter="true" :selectable="true" :hb_table_class="'hb_table_guest_vend_pc_class1'"
      :isBusy="isBusy_table1" :table_height_adjust="-10" :loading_width="100" @on_query="on_query" tableref="d3471a8c3001477490e7768d20777fa7">
      <template #query>
        物料编号：<el-input size="small" style="width: 120px" clearable v-model="ItemId"></el-input>
        物料名称：<el-input size="small" style="width: 120px" clearable v-model="InventName"></el-input>
      </template>
    </TableMain>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as api from "@/shared/api"
import * as localStorageMgr from "../../shared/localStorageMgr"
import TableMain from "../components/table/TableMain"
import BaseContainer from "../components/BaseContainer"
import SplitContainer2 from "../components/container/SplitContainer2"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import * as GuestController from "../../controllers/pages/GuestController"

export default {
  name: "GuestVendInventSumSearch",
  components: {
    TableMain,
    BaseContainer,
    Split,
    SplitContainer2,
  },
  data() {
    return {
      guest_info: null,
      tab_index: 0,
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "库存导入查询列表",
      },
      fields: GuestController.fields.inventsum_fields,
      isBusy_table1: false,
      ItemId: "",
      InventName: ""
    }
  },
  created() {
    this.guest_info = JSON.parse(this.ls.get(localStorageMgr.data.guest_info))
  },

  methods: {
    //#region table1
    ///查询
    async on_query(set_data, date_range) {
      console.log(_.map(this.fields, "key"))
      this.isBusy_table1 = true
      set_data([])
      let _fromDate = "",
        _toDate = ""
      let _params = {
        pub_token: this.ls.get("pub_guest_token"),
        ItemId: this.ItemId,
        InventName: this.InventName,
      }
      if (!_.isNull(date_range) && this.ItemId == "" && this.InventName == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), -1),
          "yyyy-MM-dd"
        )
        _params["FromDate"] = _fromDate
        _params["ToDate"] = _toDate
      }
      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_vend_inventsum"),
        parameters: _params,
        method: "get",
      })


      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        set_data(_result[0].result.data.Result[0])
      }

      this.isBusy_table1 = false
    },

  },
}
</script>

<style>
.hb_table_guest_vend_pc_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}
</style>

<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
